import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Folder from '../../../../media/felsv/FolderWhite.svg'

import PrinterIcon from '../../../../media/felsv/Printer.svg';
import DownloadIcon from '../../../../media/felsv/Download.svg';
import ReloadIcon from '../../../../media/felsv/Dark_File_Reload.svg';
import PlusFileIcon from '../../../../media/felsv/dark_file_plus.svg';
import MailIcon from '../../../../media/felsv/dark_message_icon.svg';
import MenuHorizontalIcon from '../../../../media/felsv/dark_horizontal_menu.svg';

import { getFacturaPDF_New, getQR } from '../../../../actions/operaciones/operaciones.actions';
import { setActiveHistorialFactura, setAnuladoFactura, setItemsFacturasAnular, setQRFactura, setStatusModalAnular, setStatusModalEnvio, setStatusModalImprimir, setStatusModalOpciones } from '../../../../actions/historial/historial.actions';
import { State } from '../../../../reducers';
import { formatDateToDDMMYYYY } from '../../../../utils/strings.utils';
import { generalOpenModalInfo, generalShowLoader, msgFuncionalidadLimitada, validateHorarioSucursal } from '../../../../actions/general.actions';
import { Tooltip } from '../../../../components/Tooltip/Tooltip';
import { DICCIONARIO } from '../../../../constants/Diccionario';
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton';
import { handleRestarFlujoCredito } from '../../../../actions/nota-credito.actions';
import { handleRestarFlujoDebito } from '../../../../actions/nota-debito.actions';
import { validarFechaEntreMeses } from '../../../../utils/stringDate';
import './historial.css';
import { formatearNum } from '../VisualizacionFactura/TotalesDetalle';
import { docsDatosReceptorHistorialHandleChange } from '../../../../actions/documentos/documentos.actions';
import { bindActionCreators } from 'redux';
import { actionsHistorialFiltro } from '../../../../actions/action-creators';
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm';
import {Tooltip as TooltipMaterial} from '@mui/material'
import { getTransactions, historialSetActivePage } from '../../../../actions/historial/historialFilter.actions';
import { PaginationStatic } from '../../../../components/PaginationStatic';
import { renderEstadoDoc } from '../../../../utils/estados';

export const TableHistory = () => {
  const history = useHistory();
  const refDivResults = useRef<HTMLDivElement>(null);
  const {arrayFacturas, numPagina, searchFormFilter, totalPaginas} = useSelector((state: State) => state.historial);
  const {datos} = useSelector((state: State) => state.userLogin);
  const {tipoDocumentosEmision} = useSelector((state: State) => state.catalogos);
  
  const dispatch = useDispatch();
  const [sortedArrayFacturas, setSortedArrayFacturas] = useState<Array<any>>([])
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<string[]>([]); 
  
  useEffect(() => {
    setSelectedRows([]);
    setSelectAll(false);
    dispatch(setItemsFacturasAnular([]));

    const filterPageDocs = arrayFacturas
      .map((transaccion) => ({
        ...transaccion, 
        filter_correlativo: transaccion?.DetallesDTE?.identificacion.numeroControl,
        filter_documento: tipoDocumentosEmision.find((dte) => dte.codigodocumento === transaccion?.DetallesDTE?.identificacion?.tipoDte)?.nombre || "Indefinido",
        filter_fecha: formatDateToDDMMYYYY(transaccion?.DetallesDTE?.identificacion?.fecEmi || ""),
        filter_hora: transaccion?.DetallesDTE?.identificacion?.horEmi,
        filter_total: transaccion?.DetallesDTE?.resumen?.totalPagar,
        filter_anulado: transaccion?.estadoanulacion
      }))
    
    setSortedArrayFacturas(filterPageDocs);
  }, [arrayFacturas]);

  const handleCheckboxChange = (event:any, rowId:string) => {
    if (event.target.checked) setSelectedRows([...selectedRows, rowId]); // Agrega el id de la fila seleccionada
    else setSelectedRows(selectedRows.filter((id) => id !== rowId)); // Remueve el id de la fila deseleccionada
  };

  const handlePaginacion = async (page: number) => {
    const numberPage = page - 1;
    const itemsPage = arrayFacturas.filter((fact:any) => fact?.pagina === numberPage);
    // Ya han sido cargados los datos de la pagina
    if (itemsPage.length === 0) {
      // Datos aun no cargados
      await dispatch(getTransactions(searchFormFilter, numberPage));
    }
    refDivResults?.current?.scrollIntoView({ behavior: 'smooth' });
    dispatch(historialSetActivePage(numberPage));
  }

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    if (newSelectAll) // Si "Seleccionar todos" esta marcado
      setSelectedRows([
          ...sortedArrayFacturas
          .filter(trans => trans?.estadoanulacion === "false")
          .map((transaccion) => transaccion?.DetallesDTE?.identificacion?.numeroControl)
        ]);
    else setSelectedRows([]); // Si "Seleccionar todos" está desmarcado
  };
  
  const handlePushDetail = (e:any, obj:any) => {
    dispatch(setActiveHistorialFactura({...obj}));
    dispatch(docsDatosReceptorHistorialHandleChange({nombreTipoDocumento: "", nombre: "", numId: ""}))
    if(obj?.DetallesDTE?.receptorManual?.esReceptorManual === true) {
      const datos = obj?.DetallesDTE?.receptorManual;
      dispatch(docsDatosReceptorHistorialHandleChange({nombreTipoDocumento: datos?.tipoDocManual ? datos.tipoDocManual : "", nombre: datos?.receptorManual, numId: datos?.docManual}))
    }
    dispatch(setAnuladoFactura(obj?.estadoanulacion === "true"));
    history.push('/history-invoice/detail');
  }

  const handleReimprimirFactura = (e:any, obj:any) => {
    e.stopPropagation();
    dispatch(setActiveHistorialFactura({...obj}));
    dispatch(setStatusModalImprimir(true))
  }

  const handleEnvioCorreo = (e:any, obj:any) => {
    e.stopPropagation();
    dispatch(setActiveHistorialFactura({...obj}));
    dispatch(setStatusModalEnvio(true));
  }

  const handleAnular = async (e:any, id:number = -1, isCheckSelect:boolean = false) => {
    e.stopPropagation();

    if (datos?.aspel) {
      dispatch(generalOpenModalInfo(msgFuncionalidadLimitada(datos)));
      return;
    }
    
    if(await dispatch(validateHorarioSucursal('', '/', true, 'anular los documentos seleccionados'))) {
      dispatch(setActiveHistorialFactura(null));
      dispatch(setItemsFacturasAnular(isCheckSelect ? selectedRows : [id]));
      dispatch(setStatusModalAnular(true));
    }
  }

  const handleOpciones = async (e:any, obj:any) => {
    e.stopPropagation();
    dispatch(setStatusModalOpciones(true));
    dispatch(generalShowLoader(true));
    dispatch(setActiveHistorialFactura({...obj}));
    dispatch(setAnuladoFactura(obj?.estadoanulacion === "true"));
    
    const qrRes = await getQR(obj?.documento);
    dispatch(setQRFactura(qrRes.qr));
    dispatch(generalShowLoader(false));
  }

  const handleDownload = (e:any, obj:any) => {
    e.stopPropagation();
    dispatch(setActiveHistorialFactura({...obj}));
    dispatch(getFacturaPDF_New({Documento: obj?.documento, Sello: obj?.sellorecibido}, obj?.DetallesDTE?.identificacion.numeroControl, obj.estadoanulacion));
  }

  const handleNotaCredito = (e:any, obj:any) => {
    e.stopPropagation();
    dispatch(setActiveHistorialFactura({...obj}));
    dispatch(handleRestarFlujoCredito());
    history.push('/otros-documentos/nota-credito');
  }

  const handleNotaDebito = (e:any, obj:any) => {
    e.stopPropagation();
    dispatch(setActiveHistorialFactura({...obj}));
    dispatch(handleRestarFlujoDebito());
    history.push('/otros-documentos/nota-debito');
  }

  const getTotalDocumento = (tipoDte: string, transaccion: any) => {
    const {resumen, cuerpoDocumento} = transaccion?.DetallesDTE ?? {};
    switch (tipoDte) {
      case "11":
        return `${formatearNum(parseInt(resumen?.extTotal))}`;

      case "09":
        return `${formatearNum(cuerpoDocumento?.liquidoApagar) ?? '--'}`;

      case "07":
        return `${formatearNum(parseInt(resumen?.totalSujetoRetencion))}`;

      default:
        return `${formatearNum(resumen?.totalPagar ?? resumen?.montoTotalOperacion ?? 0)}`;
    }
  }

  return (
    <div className='container-white w-100' style={{marginTop: '30px'}}>
      {
        sortedArrayFacturas.length === 0 && (<h4 className='h4-titles'>Sin resultados, realiza una búsqueda</h4>)
      }
      {
        sortedArrayFacturas.length > 0 && 
        (
          <div ref={refDivResults}>
            <BtnExcel />
            <h4 className='h4-titles'>Resultados obtenidos</h4>
            {
              (selectedRows.length > 0) && 
              (
                <div style={{display: 'flex', justifyContent: 'end', gap: '6px'}}>
                  <button className='m button btn-small delete w-auto' disabled={selectedRows.length > 5} onClick={(e) => handleAnular(e, -1, true)}>
                    Anular seleccionados {selectedRows.length > 5 && '(Máximo 5)'}
                  </button>
                </div>
              )
            }
            <hr />
            <div className='tab-plane'  style={{overflowX:'scroll'}}>
              <table className='table-main-responsive responsive-table-main td-left table-pointer'>
                <thead>
                  <tr>
                    <td>
                      <label className="w-checkbox">
                        <input autoComplete='off'  type="checkbox" checked={selectedRows.length === sortedArrayFacturas.length} onChange={handleSelectAll} />
                        <div className="checkbox__checkmark"></div>
                        <div className="checkbox__body" style={{fontWeight: '400'}}>&nbsp;</div>
                      </label>
                    </td> 
                    <td>Acciones</td>
                    <td>Correlativo</td> 
                    <td>{DICCIONARIO.TIPO_DTE} <FilterButton keyName='filter_documento' data={sortedArrayFacturas} state={(items: Array<any>) => setSortedArrayFacturas(items)}/></td>
                    <td>Estado <FilterButton keyName='filter_anulado' data={sortedArrayFacturas} state={(items: Array<any>) => setSortedArrayFacturas(items)}/></td>
                    <td>Fecha <FilterButton keyName='filter_fecha' data={sortedArrayFacturas} state={(items: Array<any>) => setSortedArrayFacturas(items)}/></td>
                    <td>Hora <FilterButton keyName='filter_hora' data={sortedArrayFacturas} state={(items: Array<any>) => setSortedArrayFacturas(items)}/></td>
                    <td>Total <FilterButton keyName='filter_total' data={sortedArrayFacturas} state={(items: Array<any>) => setSortedArrayFacturas(items)}/></td>
                  </tr>
                </thead>
                <tbody>
                  {
                    sortedArrayFacturas.filter((fact:any) => fact.pagina === numPagina).map((transaccion, index) => (
                      <tr key={index} onClick={(e) => handlePushDetail(e, transaccion)}>
                        {/* CHECKBOX CON NUMERO DE CONTROL */}
                        <td data-label='Selección  ' onClick={(e) => e.stopPropagation()}>
                          <label className="w-checkbox">
                            <input autoComplete='off' 
                              type="checkbox"
                              disabled={transaccion?.estadoanulacion === "true"}
                              checked={selectedRows.includes(transaccion?.DetallesDTE?.identificacion.numeroControl)}
                              onChange={(e) => {handleCheckboxChange(e, transaccion?.DetallesDTE?.identificacion.numeroControl);}}
                              />
                            <div className="checkbox__checkmark"></div><div className="checkbox__body fw-400">&nbsp;</div>
                          </label>
                        </td>
                        {/* ACCIONES */}
                        <td data-label='Acciones' className='table-td'>
                          <Tooltip content='Imprimir'>
                            <button className='table-action' onClick={(e) => handleReimprimirFactura(e, transaccion)}>
                              <img src={PrinterIcon} alt='Printer' className='table-img-action' />
                            </button>
                          </Tooltip>
                          <Tooltip content='Enviar'>
                            <button className='table-action' onClick={(e) => handleEnvioCorreo(e, transaccion)}>
                              <img src={MailIcon} alt='Mail' className='table-img-action' />
                            </button>
                          </Tooltip>
                          <Tooltip content='Descargar PDF'>
                            <button className='table-action' onClick={(e) => handleDownload(e, transaccion)}>
                              <img src={DownloadIcon} alt='Delete' className='table-img-action' />
                            </button>
                          </Tooltip>
                          {/* NOTA DEBITO Y CREDITO */}
                          {
                            (
                              transaccion?.DetallesDTE?.identificacion?.tipoDte === "03" && 
                              transaccion?.estadoanulacion === "false" &&
                              validarFechaEntreMeses(3, transaccion?.DetallesDTE?.identificacion?.fecEmi)
                            )
                            &&
                            (
                              <>
                                <Tooltip content='Nota de crédito'>
                                  <button className='table-action' onClick={(e) => handleNotaCredito(e, transaccion)}>
                                    <img src={ReloadIcon} alt='Nota crédito' className='table-img-action' />
                                  </button>
                                </Tooltip>
                                <Tooltip content='Nota de débito'>
                                  <button className='table-action' onClick={(e) => handleNotaDebito(e, transaccion)}>
                                    <img src={PlusFileIcon} alt='Nota débito' className='table-img-action' />
                                  </button>
                                </Tooltip>
                              </>
                            )
                          }
                          <Tooltip content='Ver más opciones'>
                            <button className='table-action' onClick={(e) => handleOpciones(e, transaccion)}>
                              <img src={MenuHorizontalIcon} alt='Options' className='table-img-action' />
                            </button>
                          </Tooltip>
                        </td>   
                        {/* CORRELATIVO */}   
                        <td data-label='Correlativo'>
                          <div className="fw-400">{transaccion?.DetallesDTE?.identificacion.numeroControl}</div>
                        </td>           
                        {/* TIPO DE DOCUMENTO */}
                        <td data-label={DICCIONARIO.TIPO_DTE}>{tipoDocumentosEmision.find((dte) => dte.codigodocumento === transaccion?.DetallesDTE?.identificacion?.tipoDte)?.nombre || "Indefinido"}</td>
                        {/* ESTADO DOCUMENTO */}
                        <td data-label='Estado'>
                          <div style={{justifyContent: 'left', width: '100%', display: 'flex', flexDirection: 'column', gap: '5px'}}>
                            {renderEstadoDoc(transaccion, { esTransaccion: true })}
                          </div>
                        </td>
                        {/* FECHA */}
                        <td data-label='Fecha'>{formatDateToDDMMYYYY(transaccion?.DetallesDTE?.identificacion?.fecEmi || "")}</td>
                        {/* HORA */}
                        <td data-label='Hora'>{transaccion?.DetallesDTE?.identificacion?.horEmi}</td>
                        {/* TOTAL OPERACION */}
                        <td data-label='Total'>
                          {
                            getTotalDocumento(transaccion?.DetallesDTE?.identificacion?.tipoDte, transaccion)
                          }
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
              <PaginationStatic 
                pagesDefault={totalPaginas}
                onChangeCurrentPage={handlePaginacion} 
                items={20} 
              />
            </div>
          </div>
        )
      }
    </div>
  )
}

const BtnExcel = () => {
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch();
  const {downloadExcel} = bindActionCreators(actionsHistorialFiltro, dispatch)
  return (
    <div  style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'end' }}>
      {open && <ModalConfirm
        title='Generar historial de documentos'
        detail={(<>¿Deseas generar el historial de documentos en formato .xlsx? <br/><br/> <b>Nota</b>: Al finalizar el proceso, se enviará un correo electrónico con el enlace de descarga. El tiempo de entrega del correo dependerá de la cantidad de facturas a procesar.</>)}
        messageAction='Descargar'
        actionConfirm={() => { downloadExcel(); setOpen(false) }}
        messageClose='Cancelar'
        closeModalConfirm={() => setOpen(false)}
        Styles={{minWidth: '25%', maxWidth: '550px'}}
      />}
      <TooltipMaterial title='Descargar Historial' placement="left" arrow>
        <button className='m button botton-footer' style={{width:"50px", minWidth:"50px"}} onClick={() => setOpen(true)}><img src={Folder} alt='Download folder'/></button>
      </TooltipMaterial>
    </div>
  )
}